// Not a polyfill, but a wrapper around localStorage to have events when it changes
// See https://stackoverflow.com/a/69380917
Storage.prototype.setItem = new Proxy(Storage.prototype.setItem, {
  apply(target, thisArg, argumentList) {
    const event = new CustomEvent('localstorage', {
      detail: {
        key: argumentList[0],
        oldValue: thisArg.getItem(argumentList[0]),
        newValue: argumentList[1],
      },
    });
    const fn = Reflect.apply(target, thisArg, argumentList);
    window.dispatchEvent(event);
    return fn;
  },
});
